import { UitkLayoutFlexProps, UitkLayoutFlexItemProps } from "uitk-react-layout-flex";
import { FlexComponentProps, FlexComponent } from "typings/flexFramework/FlexComponent";
import {
  TripAttachQualificationFlexModuleResult,
  DestinationImageData,
} from "typings/microserviceModels/trip-attach-qualification-flex-module";
import { TripAttachQualificationMipType } from "./TripAttachQualification";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { ThumborStore } from "stores/thumbor/ThumborStore";
import { CompositionStore } from "src/stores/CompositionStore";
import { FlexViewModelStore } from "src/stores/flexViewModel/FlexViewModelStore";

export interface TripAttachQualificationFlexComponent extends FlexComponent {
  model: TripAttachQualificationFlexModuleResult;
}

export interface TripAttachQualificationProps extends FlexComponentProps {
  compositionStore: CompositionStore;
  flexComponent: TripAttachQualificationFlexComponent;
  flexViewModel: FlexViewModelStore;
}

export interface TripAttachQualificationViewProps {
  moduleName: string;
  destinationName: string;
  imageData?: DestinationImageData;
  percentageOff: number;
  tripStartDate: string;
  tripEndDate: string;
  deepLink: string;
  deepLinkMipType: TripAttachQualificationMipType;
}

export interface TripCardProps {
  moduleName: string;
  destinationName: string;
  imageData?: DestinationImageData;
  tripStartDate: string;
  tripEndDate: string;
  withBorder: boolean;
}

export interface ImagePlaceholderProps {
  alt: string;
}

export interface TripImageProps {
  destinationName: string;
  imageData?: DestinationImageData;
  context?: ExtendedContextStore;
  thumbor?: ThumborStore;
}

export interface AttachSavingsCardProps {
  deepLink: string;
  deepLinkMipType: TripAttachQualificationMipType;
  moduleName: string;
  percentageOff: number;
  withBorder: boolean;
  padded: boolean;
}

export interface SavingsContentProps {
  deepLink: string;
  deepLinkMipType: TripAttachQualificationMipType;
  moduleName: string;
  percentageOff: number;
}

export interface SavingsInfo {
  action: string;
  message: string;
  rfrr: string;
}

export interface TripCardContentProps {
  destinationName: string;
  imageData?: DestinationImageData;
  tripEndDate: string;
  tripStartDate: string;
  tripTitle: string;
}

export enum ViewportSizes {
  SMALL = "small",
  LARGE = "large",
}

export interface ViewportConfig {
  wrap: UitkLayoutFlexProps["wrap"];
  minWidth: UitkLayoutFlexItemProps["minWidth"];
}

export interface ViewportConfigs {
  [ViewportSizes.SMALL]: ViewportConfig;
  [ViewportSizes.LARGE]: ViewportConfig;
}

export const viewportConfigs: ViewportConfigs = {
  [ViewportSizes.SMALL]: { wrap: "wrap", minWidth: "full_width" },
  [ViewportSizes.LARGE]: { wrap: "nowrap", minWidth: "half_width" },
};
